var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('div',{staticClass:"alert alert-danger alert-dark-danger text-center"},[_vm._v(" "+_vm._s(_vm.$t('sentence.error_message_close_window'))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }